<template>
  <div>
    <div class="dianquan_banner">
      <!--      <img /> -->
      <div class="gamesDetail_bannerDetail">
        <img :src="gamesDetail.imgUrl" class="gamesDetail_banner_img" />
        <div class="gamesDetail_banner_text">{{gamesDetail.name}}</div>
      </div>
    </div>
    <div class="dianquan_text">{{gamesDetail.text}}</div>
    <div class="gamesDetail_quan_List1 ">
      <div :class="item.shopSelect ? 'gamesDetail_dianquan_box1' : 'gamesDetail_dianquan_box'"
        v-for="(item,index) in gamesDetail.gamesDetailbox" @click="changedianquan(index)">
        <div>{{item.price}}元</div>
        <div>{{gamesDetail.type}}</div>
      </div>
      <div class="gamesDetail_buybutton">立即购买</div>
    </div>
<!--    <img src="/static/quse1.png" /> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        gamesDetailId: 0,
        gamesDetail: {},
        gamesDetailList: [{
          imgUrl: "/static/wangyiyouxibanner.png",
          name:"网易游戏",
          text:"购买充值卡",
          type:"兑换券",
          gamesDetailbox: [{
            price: "5",
            shopSelect: true
          }, {
            price: "20",
            shopSelect: false
          }, {
            price: "30",
            shopSelect: false
          }, {
            price: "50",
            shopSelect: false
          }, {
            price: "100",
            shopSelect: false
          }, {
            price: "200",
            shopSelect: false
          }]
        }, {
          imgUrl: "/static/shengdabanner.png",
          name:"盛大网络",
          text:"购买充值卡",
          type:"充值卡",
          gamesDetailbox: [{
            price: "5",
            shopSelect: false
          }, {
            price: "20",
            shopSelect: false
          }, {
            price: "30",
            shopSelect: false
          }, {
            price: "50",
            shopSelect: false
          }, {
            price: "100",
            shopSelect: false
          }, {
            price: "200",
            shopSelect: false
          }]
        }, {
          imgUrl: "/static/wanmei.png",
          name:"完美世界",
          text:"购买充值卡",
          type:"充值卡",
          gamesDetailbox: [{
            price: "5",
            shopSelect: false
          }, {
            price: "20",
            shopSelect: false
          }, {
            price: "30",
            shopSelect: false
          }, {
            price: "50",
            shopSelect: false
          }, {
            price: "100",
            shopSelect: false
          }, {
            price: "200",
            shopSelect: false
          }]
        }, {
          imgUrl: "/static/kongzhongbanner.png",
          name:"空中网",
          text:"购买充值卡",
          type:"充值卡",
          gamesDetailbox: [{
            price: "5",
            shopSelect: false
          }, {
            price: "20",
            shopSelect: false
          }, {
            price: "30",
            shopSelect: false
          }, {
            price: "50",
            shopSelect: false
          }, {
            price: "100",
            shopSelect: false
          }, {
            price: "200",
            shopSelect: false
          }]
        }, {
          imgUrl: "/static/jinshanbanner.png",
          name:"金山",
          text:"购买充值卡",
          type:"充值卡",
          gamesDetailbox: [{
            price: "5",
            shopSelect: false
          }, {
            price: "20",
            shopSelect: false
          }, {
            price: "30",
            shopSelect: false
          }, {
            price: "50",
            shopSelect: false
          }, {
            price: "100",
            shopSelect: false
          }, {
            price: "200",
            shopSelect: false
          }]
        }, {
          imgUrl: "/static/souhuyulebanner.png",
          name:"搜狐",
          text:"购买充值卡",
          type:"充值卡",
          gamesDetailbox: [{
            price: "5",
            shopSelect: false
          }, {
            price: "20",
            shopSelect: false
          }, {
            price: "30",
            shopSelect: false
          }, {
            price: "50",
            shopSelect: false
          }, {
            price: "100",
            shopSelect: false
          }, {
            price: "200",
            shopSelect: false
          }]
        }, {
          imgUrl: "/static/jurenbanner.png",
          name:"巨人网络",
          text:"购买充值卡",
          type:"充值卡",
          gamesDetailbox: [{
            price: "5",
            shopSelect: false
          }, {
            price: "20",
            shopSelect: false
          }, {
            price: "30",
            shopSelect: false
          }, {
            price: "50",
            shopSelect: false
          }, {
            price: "100",
            shopSelect: false
          }, {
            price: "200",
            shopSelect: false
          }]
        }, {
          imgUrl: "/static/guangyubanner.png",
          name:"光宇",
          text:"购买充值卡",
          type:"充值卡",
          gamesDetailbox: [{
            price: "5",
            shopSelect: false
          }, {
            price: "20",
            shopSelect: false
          }, {
            price: "30",
            shopSelect: false
          }, {
            price: "50",
            shopSelect: false
          }, {
            price: "100",
            shopSelect: false
          }, {
            price: "200",
            shopSelect: false
          }]
        }, {
          imgUrl: "/static/jiuyoubanner.png",
          name:"久游",
          text:"购买充值卡",
          type:"充值卡",
          gamesDetailbox: [{
            price: "5",
            shopSelect: false
          }, {
            price: "20",
            shopSelect: false
          }, {
            price: "30",
            shopSelect: false
          }, {
            price: "50",
            shopSelect: false
          }, {
            price: "100",
            shopSelect: false
          }, {
            price: "200",
            shopSelect: false
          }]
        }]

      }
    },
    created() {
      if (this.$route.query.gamesDetailId != 'undefined') {
        this.gamesDetailId = this.$route.query.gamesDetailId
        let that = this
        that.gamesDetail = that.gamesDetailList[Number(that.gamesDetailId)]
        // that.videoname = that.videoDetail.name
        // console.log("videoDetail", that.videoDetail)
      }
    },
    mounted() {

    },
    methods: {
      changedianquan(e) {
        let that = this
        let gamesDetail = that.gamesDetail
        gamesDetail.gamesDetailbox.map((item, index) => item.shopSelect = index === Number(e))
      }
    }
  }
</script>

<style>
  .gamesDetail_quan_List {
    margin: 20px;
  }

  .gamesDetail_quan_List1 {
    margin: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .gamesDetail_quan_box {
    display: flex;
    margin: 20px 0;
    border: 3px solid #FFFFFF;
  }

  .gamesDetail_quan_box1 {
    display: flex;
    margin: 20px 0;
    border: 3px solid #EE9D27;
  }

  .gamesDetail_box_left {
    width: 40%;
    height: 90px;
  }

  .gamesDetail_box_left_img {
    width: 100%;
    height: 100%;
  }

  .gamesDetail_box_right {
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: aliceblue;
  }

  .gamesDetail_right_top {
    display: flex;
    width: 170px;
  }

  .gamesDetail_rightl {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50px;
    margin: 5px;
  }

  .gamesDetail_daijin {}

  .gamesDetail_fenjie {
    border-bottom: 1px dashed #9d9797;
    width: 40px;
    margin-top: 5px;
  }

  .gamesDetail_rmb {}

  .gamesDetail_rightc {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 5px;
    font-size: 40px;
    width: 70px;
  }

  .gamesDetail_rightr {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-left: 20px;
    margin-bottom: 10px;
  }

  .gamesDetail_right_bottom {
    border: 1px dashed #9d9797;
    width: 170px;
  }

  .gamesDetail_buybutton {
    margin: 20px 50px;
    height: 50px;
    width: 75%;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
   background-color: #58b4c1;
    color: #FFFFFF;
  }

  .dianquan_banner {
    width: 90%;
    height: 160px;
/*    background-color: #583e36; */
background: -webkit-linear-gradient(bottom, hsl(202, 37%, 90%), hsl(226, 100%, 84%), #3b6bfb) no-repeat;
    margin: 20px;
  }

  .gamesDetail_bannerDetail {
    /*    margin-left: 20px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .gamesDetail_banner_img {
    width: 70px;
    height: 70px;
    border-radius: 35px;
    margin-bottom: 20px;
  }

  .gamesDetail_banner_text {
    color: #FFFFFF;
    font-size: 22px;
  }
  .gamesDetail_lipin_box {
    background-image: url(../../../static/lipinka.png);
    background-size: cover;
    width: 118px;
    height: 120px;
    border-radius: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 20px;
    margin: 10px 0;
    color: #525151;
  }
  .gamesDetail_lipin_box1 {
    background-image: url(../../../static/lipinka11.png);
    background-size: cover;
    width: 118px;
    height: 120px;
    border-radius: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 20px;
    margin: 10px 0;
    color: #f0aa64;
  }
  .gamesDetail_dianquan_box {
    background-image: url(../../../static/quan.png);
    background-size: cover;
    width: 118px;
    height: 120px;
    border-radius: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 20px;
    margin: 10px 0;
     color: #525151;
  }

  .gamesDetail_dianquan_box1 {
    background-image: url(../../../static/quan1.png);
    background-size: cover;
    width: 118px;
    height: 120px;
    border-radius: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 20px;
    margin: 10px 0;
    color: #f0aa64;
    /*   color: #FFFFFF; */
  }

  .dianquan_text {
    margin: 20px;
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/games/gamesDetail.vue